import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksAllFieldWorks(companyId, query) {
  return dataTransferWrap(
    ModulesMap.DONE_WORKS_ALL_FIELD_WORKS,
    dtConfig[ModulesMap.DONE_WORKS_ALL_FIELD_WORKS].getDoneWorksAllFieldWorks,
    {
      urlParams: {
        companyId,
      },
      params: query,
    },
  )
}

export default {
  getDoneWorksAllFieldWorks,
}